import { render, staticRenderFns } from "./liChengAccounts.vue?vue&type=template&id=ec701c18&scoped=true"
import script from "./liChengAccounts.vue?vue&type=script&lang=js"
export * from "./liChengAccounts.vue?vue&type=script&lang=js"
import style0 from "./liChengAccounts.vue?vue&type=style&index=0&id=ec701c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec701c18",
  null
  
)

export default component.exports